import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'

class TourNote extends Component {
  render() {
    return (
      <div className="absolute left-0 top-[-38px] text-nowrap text-white text-center bg-black/20 leading-none">
        Testez votre assistant juridique<br />
        &#8595;
      </div>
    )
  }
}

class CustomerNavigationLink extends Component {
  render() {
    const { icon, label, route, focus, disabled, caarlTourActive, additionnalOnClick, closeMenu } = this.props
    const hasFocus = focus === route
    const focusClass = hasFocus ? 'navigation-focus' : ''
    const disabledClass = disabled ? 'navigation-disabled' : ''
    const zIndexClass = caarlTourActive ? 'z-[1000] relative' : ''
    const bgClass = caarlTourActive ? 'bg-[#304061]' : ''

    const onClick = (e) => {
      if (disabled) {
        e.preventDefault()
        return
      }
      closeMenu && closeMenu()
      additionnalOnClick && additionnalOnClick(e)
    }

    return (
      <Link to={route} onClick={onClick} className={zIndexClass}>
        {hasFocus && <div className="navigation-focus-border" />}
        {caarlTourActive ? <TourNote /> : null}
        <div className={`customer-navigation-link ${focusClass} ${disabledClass} ${bgClass}`}>
          <div className="customer-navigation-icon">
            <img src={`/assets/icons/${icon}${hasFocus ? '-focus' : ''}.svg`} alt={label} />
          </div>
          <div>{label}</div>
        </div>
      </Link>
    )
  }
}

export default withRouter(CustomerNavigationLink)
